module.exports = __webpack_public_path__ + "static/media/subscriptions.c033769e.svg";